module.exports = __webpack_public_path__ + "h5/img/bs_13.2668cb62.jpg";